import React from 'react';
import { View, Text, StyleSheet, ActivityIndicator, TouchableOpacity } from 'react-native';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { colores } from '../../../../styles/variablesCss';
import { useNavigation } from '@react-navigation/native';
import { useCart } from '../../../../context/CartContext';
import TemplateCarrito from './TemplateCarrito';

const Carrito = ({ onCheckout, onClose }) => {
  // Usar el contexto del carrito centralizado
  const { 
    productos, 
    loading, 
    error, 
    totales,
    cargarProductosCarrito,
    vaciarCarrito,
    calcularTotal,
    emitCarritoActualizado
  } = useCart();
  
  const navigation = useNavigation();
  
  // Función por defecto de checkout si no se proporciona una
  const handleCheckout = () => {
      onClose();
    // Navegar al checkout
    navigation.navigate('CheckoutFinalizarCompra');
  };
  
  // Función de recarga que también emite el evento
  const recargarYNotificar = async () => {
    await cargarProductosCarrito();
    emitCarritoActualizado();
  };
  
  // Renderizado condicional según el estado
  if (loading) {
    return (
      <View style={styles.loadingContainer}>
        <ActivityIndicator size="large" color={colores.rojo} />
        <Text style={styles.loadingText}>Cargando carrito...</Text>
      </View>
    );
  }

  if (error) {
    return (
      <View style={styles.errorContainer}>
        <MaterialCommunityIcons name="alert-circle" size={50} color={colores.error} />
        <Text style={styles.errorText}>{error}</Text>
        <TouchableOpacity 
          style={styles.reloadButton} 
          onPress={cargarProductosCarrito}
        >
          <Text style={styles.reloadButtonText}>Reintentar</Text>
        </TouchableOpacity>
      </View>
    );
  }
  
  if (!productos || productos.length === 0) {
    return (
      <View style={styles.emptyContainer}>
        <MaterialCommunityIcons name="cart-outline" size={50} color={colores.grisClaro} />
        <Text style={styles.emptyText}>Tu carrito está vacío</Text>
      </View>
    );
  }

  return (
    <TemplateCarrito 
      productos={productos}
      onCheckout={onCheckout || handleCheckout}
      total={calcularTotal()}
      subtotal={totales.subtotal}
      descuentos={totales.descuentos}
      onRefresh={recargarYNotificar}
      onVaciarCarrito={vaciarCarrito}
    />
  );
};

const styles = StyleSheet.create({
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  loadingText: {
    marginTop: 10,
    color: colores.textoSecundario,
  },
  errorContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  errorText: {
    marginTop: 10,
    marginBottom: 15,
    color: colores.error,
    textAlign: 'center',
  },
  reloadButton: {
    backgroundColor: colores.rojo,
    paddingHorizontal: 15,
    paddingVertical: 8,
    borderRadius: 5,
  },
  reloadButtonText: {
    color: colores.blanco,
    fontWeight: 'bold',
  },
  emptyContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
    flex: 1,
  },
  emptyText: {
    fontSize: 16,
    color: colores.secondary,
    marginTop: 10,
  },
});

export default Carrito;